import apiService from 'library/api-service';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getConnectionTypes = createAsyncThunk('getConnectionTypes', async () => {
  const response = await apiService.getConnectionTypes();

  return { connectionTypes: response.data };
});

const connectionTypesActions = { getConnectionTypes };

export default connectionTypesActions;
